import { render } from "./AlteracaoEmMassaProdutos.vue?vue&type=template&id=0d54dbea&scoped=true&ts=true"
import script from "./AlteracaoEmMassaProdutos.vue?vue&type=script&lang=ts"
export * from "./AlteracaoEmMassaProdutos.vue?vue&type=script&lang=ts"

import "./AlteracaoEmMassaProdutos.vue?vue&type=style&index=0&id=0d54dbea&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d54dbea"]])

export default __exports__